import { CurrentUserDto } from 'services/user/userService.dto';

export const extractUserFacebookName = (user: CurrentUserDto) => {
  if (!user) {
    return '';
  }
  return user.facebookVerified ? `${user.facebookFirstName} ${user.facebookLastName}` : '';
};
